import React, { useState } from 'react';
import cx from 'classnames';
import { ArrowDownV2 } from '../../../icons/index.js';
import styles from './index.module.scss.js';
import { ExpandContent } from '../../../common/ExpandContent/index.js';

const Accordion = ({
  title,
  animations = {},
  children,
  mobileSmallPadding,
  textWhite,
  smallGap,
  className,
  style,
  ...props
}) => {
  const [isActive, setIsActive] = useState(false);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, className, "accordion", {
        [styles.open]: isActive,
        [styles["mobile-small-padding"]]: mobileSmallPadding,
        [styles["text-white"]]: textWhite,
        [styles["small-gap"]]: smallGap
      }),
      style,
      ...animations
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        onClick: () => {
          setIsActive((prev) => !prev);
        },
        className: cx(styles.button, "accordion__button")
      },
      title,
      /* @__PURE__ */ React.createElement(ArrowDownV2, { className: cx(styles.icon, "accordion__arrow") })
    ),
    /* @__PURE__ */ React.createElement(
      ExpandContent,
      {
        isActive,
        style: {
          width: "100%"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: cx(styles.panel, "accordion__panel") }, children)
    )
  );
};
Accordion.displayName = "Accordion";

export { Accordion };
//# sourceMappingURL=index.js.map
